import * as StoreInformationActions from './screeninformation.actions';
import { ScreenInformation } from './screeninformation.model';

export interface State {
  screenInformation: ScreenInformation[];
}

const initialState: State = {


  screenInformation: []

};

export function screenInformationReducer(state = initialState, action: StoreInformationActions.StoreInformationActions) {
  switch (action.type) {
    case (StoreInformationActions.ADD_STORE_INFORMATION):

      const updatedScreenInformation = [
        ...action.payload
      ];


      let updatedScreenInformations = [...state.screenInformation];
      updatedScreenInformations = updatedScreenInformation;

      return {
        ...state,
        screenInformation: updatedScreenInformations
      };

    default:
      return state;
  }
}
